import { render, staticRenderFns } from "./OmrDoughnutApexChart.vue?vue&type=template&id=f1af1a54&scoped=true&"
import script from "./OmrDoughnutApexChart.vue?vue&type=script&lang=js&"
export * from "./OmrDoughnutApexChart.vue?vue&type=script&lang=js&"
import style0 from "./OmrDoughnutApexChart.vue?vue&type=style&index=0&id=f1af1a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1af1a54",
  null
  
)

export default component.exports